export const EditSVG = (props) => (
  <svg height={17} viewBox="0 0 16 17" width={16} {...props}>
    <filter id="a" colorInterpolationFilters="auto">
      <feColorMatrix
        in="SourceGraphic"
        type="matrix"
        values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
      />
    </filter>
    <g
      fill="none"
      fillRule="evenodd"
      filter="url(#a)"
      transform="translate(-28.001684 1)"
    >
      <g transform="translate(27.999586)">
        <path
          d="m13.000414 15.5h-13.000414"
          stroke="#000"
          strokeLinejoin="round"
        />
        <path
          d="m7.5813154 11.5458463 7.0576144-9.29653811s.8733259-1.28232675-.0948978-2.01281629c-.9682238-.73048954-1.9576834.46449607-1.9576834.46449607l-7.05695081 9.29653809-1.5289839 4.00247394z"
          stroke="#000"
          strokeLinejoin="round"
        />
        <path d="m4.84665407 12-.84624018 2 2-1.2394437z" fill="#1d1d1b" />
      </g>
    </g>
  </svg>
);
